import React from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import _get from "lodash/get";
import DetailedField from "./DetailedField";
import { formatFieldValue } from "../../../utilities/detailedViewHelpers";

const DetailedGroupCard = ({ group, fields, dataContext, generalInfo }) => {
  if (group.visibility && !group.visibility(dataContext, generalInfo)) {
    return null;
  }

  const visibleFields = fields.filter((field) => {
    // Exclude notice type fields from detailed view
    if (field.type === "notice") {
      return false;
    }
    return !field.visibility || field.visibility(dataContext, generalInfo);
  });

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <Card sx={{ mb: 2 }} variant="outlined" key={group.name}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1, borderBottom: "1px solid #ccc", pb: 0.5 }}>
          {group.label}
        </Typography>
        <Grid container spacing={1}>
          {visibleFields.map((field) => {
            const value = _get(dataContext, field.name);
            const formattedValue = formatFieldValue(value, field, generalInfo);
            return <DetailedField key={field.name} label={field.label} value={formattedValue} />;
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DetailedGroupCard;
